import { render, staticRenderFns } from "./FacebookLoginButton.vue?vue&type=template&id=70ced518&scoped=true&"
import script from "./FacebookLoginButton.vue?vue&type=script&lang=js&"
export * from "./FacebookLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./FacebookLoginButton.vue?vue&type=style&index=0&id=70ced518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ced518",
  null
  
)

export default component.exports